import React, {useMemo, useState} from 'react'
import {Button, FormControl, InputGroup} from 'react-bootstrap'
import {Student} from '../student/type'
import CRUDTable from '../../../components/table/CRUDTable'
import DeleteButton from '../../../components/DeleteButton'
import toast from 'react-hot-toast'
import ModalWithForm from '../../../components/ModalWithForm'
import LinkStudentToGuardian from './LinkStudentToGuardian'
import {unlinkStudentFromGuardian} from './api'

interface LinkedStudentsTableProps {
  studentData: Student[]
  refetchStudentData: () => Promise<any>
  guardianId: string | number
}

const LinkedStudentsTable: React.FC<LinkedStudentsTableProps> = ({
  studentData,
  refetchStudentData,
  guardianId,
}) => {
  const [searchInput, setSearchInput] = useState('')

  const filteredData = useMemo(
    () =>
      studentData.filter(
        (item) =>
          item.student_name.toLowerCase().includes(searchInput.toLowerCase()) ||
          (item.regID && item.regID.toLowerCase().includes(searchInput.toLowerCase()))
      ),
    [studentData, searchInput]
  )
  return (
    <>
      <CRUDTable
        formSize="sm"
        isSearchable={false}
        fieldToLabelMap={{
          student_name: 'Student Name',
          regID: 'Reg. Id',
          class: 'Class',
          division: 'division',
          remove: 'Remove',
        }}
        noDataMessage="No students linked to this guardian"
        headerExtras={
          <div className="d-flex justify-content-between w-100">
            <InputGroup size="sm" aria-describedby="search" style={{width: '65%'}}>
              <InputGroup.Text id="search">Search</InputGroup.Text>
              <FormControl
                placeholder="Search by Student name or Registration Id"
                aria-label="Search"
                aria-describedby="search"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
            </InputGroup>
            <div style={{width: '30%', textAlign: 'right'}}>
              <ModalWithForm
                Form={LinkStudentToGuardian}
                initialValues={{existingLinkedStudents: studentData, parent_id: guardianId}}
                modalTitle={'Link Student to Guardian'}
                modalAttrs={{size: 'sm'}}
                onSubmit={refetchStudentData}
              >
                <Button size="sm" variant="outline-primary" className=" border border-primary">
                  Link Student to Guardian
                </Button>
              </ModalWithForm>
            </div>
          </div>
        }
        data={filteredData || []}
        cellModifier={{
          remove: ({row}: {row: {original: Student}}) => (
            <DeleteButton
              onDelete={async () => {
                const toastId = toast.loading('Removing Please wait...')
                try {
                  const response = await unlinkStudentFromGuardian({
                    student_id: row.original.student_id,
                    parent_id: guardianId,
                  })
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetchStudentData()
                  toast.success('Unlinked student from guardian successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            />
          ),
        }}
      />
    </>
  )
}

export default LinkedStudentsTable
